import { useMutation, useQueryClient } from "react-query";
import http from "infra/http";
import { LancarContaRecorrenteForm } from "../typings";
import { AxiosError } from "axios";

function useLancarContaRecorrente(id: string) {
  const queryClient = useQueryClient();
  return useMutation<
    { data: string },
    AxiosError<string>,
    LancarContaRecorrenteForm,
    unknown
  >(
    `v1/conta-recorrente/lancamento`,
    (form: LancarContaRecorrenteForm) =>
      http.post(`/v1/conta-recorrente/${id}/lancamento`, form),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: ({ queryKey }) =>
            typeof queryKey === "string" &&
            queryKey.startsWith("/v1/conta-recorrente"),
        });
      },
    }
  );
}

export default useLancarContaRecorrente;
